import { IconEdit } from '@/icons';
import { Button } from '@/ui/Button/Button';
import { Flex } from '@/ui/Flex/Flex';
import { Input } from '@/ui/Input/Input';
import { Modal } from '@/ui/Modal/Modal';
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styled, { css } from 'styled-components';
import { T } from '../Text/Text';
import { Tooltip } from '../Tooltip/Tooltip';

const StyledFooter = styled(Flex)`
  padding: 18px 32px 32px;
`;

const StyledSaveButton = styled(Button)`
  ${({ disabled }) =>
    disabled &&
    css`
      background-color: ${({ theme }) => theme.color('#B2B1BA')};
      pointer-events: none;
    `}

  width: 100px;
  align-self: flex-end;
`;

type Props = {
  disabled?: boolean;
  onSave: (value: string) => void;
  initialValue: string;
  title: React.ReactNode;
  placeholder?: string;
};

export const EditTextModal = ({
  disabled = false,
  onSave,
  initialValue,
  title,
  placeholder,
}: Props) => {
  const [inputValue, setInputValue] = useState(initialValue);
  const [isOpen, setIsOpen] = useState(false);

  const handleSave = () => {
    if (inputValue.trim()) {
      setIsOpen(false);
      onSave(inputValue.trim());
    }
  };

  const handleKeyDown = (event: KeyboardEvent) => {
    if (event.key === 'Enter') {
      handleSave();
    }
  };

  const handleEditButtonClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (!disabled) {
      e.stopPropagation();
      setIsOpen(true);
    }
  };

  return (
    !disabled && (
      <div>
        <Flex align="center" justify="space-between">
          <Flex align="center" gap={8} justify="space-between">
            <T h4>{initialValue}</T>
            <Tooltip title="Edit group name.">
              <span
                style={{ cursor: 'pointer' }}
                onClick={handleEditButtonClick}
              >
                <IconEdit />
              </span>
            </Tooltip>
          </Flex>
        </Flex>

        {isOpen && (
          <Modal
            footer={
              <StyledFooter grow justify="flex-end">
                <StyledSaveButton
                  disabled={!inputValue.trim()}
                  onClick={handleSave}
                >
                  <FormattedMessage defaultMessage="Save" id="jvo0vs" />
                </StyledSaveButton>
              </StyledFooter>
            }
            onClose={() => setIsOpen(false)}
            title={title}
          >
            <Input
              onChange={(value) => setInputValue(value)}
              value={inputValue}
              onKeyDown={handleKeyDown}
              placeholder={placeholder}
            />
          </Modal>
        )}
      </div>
    )
  );
};

export default EditTextModal;
